// types
import { i18nEaiMessages } from 'models/i18n';

// ==============================|| I18N EN MESSAGES ||============================== //

const enEaiMessages: i18nEaiMessages = {
  changeEmsMemberAccountSubscription: 'Service level successfully changed',
  createEmsParty: 'Subject successfully created',
  updateEmsParty: 'Subject successfully updated',
  deleteEmsParty: 'Subject successfully removed',
  createEmsMemberAccount: 'Subject account successfully created',
  updateEmsMemberAccount: 'Subject account successfully updated',
  activateEmsMemberAccount: 'Subject account recovered successfully',
  deactivateEmsMemberAccount: 'Subject account invalidated successfully',
  updateMarketParticipant: 'Market participant successfully updated',
  addMarketParticipantCredentials: 'Credentials successfully added',
  removeMarketParticipantCredentials: 'Credentials successfully removed',
  createEmsMemberAccountUser: 'User successfully created',
  createDeliveryPoint: 'Delivery point successfully created',
  updateDeliveryPoint: 'Delivery point successfully updated',
  updateDeliveryPointCharacteristics:
    'Delivery point characteristics successfully updated',
  updateDeliveryPointGDSName: 'GDS name updated',
  enableUserAccount: 'User account enabled successfully',
  disableUserAccount: 'User account disabled successfully',
  resetUserPassword: 'User password change request has been sent',
  updateUser: 'User account updated successfully',
  deleteUser: 'User deleted successfully',
  assignEmsMemberAccountUser: 'Member account successfully assigned to user',
  unassignEmsMemberAccountUser:
    'Member account successfully unassigned to user',
  addUserRole: 'User role successfully added',
  deleteUserRole: 'User role successfully deleted',
  updateBalanceGroup: 'Balance group updated successfully',
  updateBalanceGroupCharacteristics:
    'Balance group characteristics successfully updated',
  createDevice: 'Device successfully created',
  updateDevice: 'Device successfully updated',
  assignGDS: 'Assignment of the device to the GDS successfully updated',
  registerGDSToDeliveryPoint: 'Delivery point created',
  unassignGDSFromDeliveryPoint: 'Delivery point unassigned',
  updateDeviceCharacteristicGroupCharacteristics:
    'Device characteristics successfully updated',
  createDeviceCharacteristicGroup:
    'Device characteristic group successfully created',
  deleteDevice: 'Device successfully deleted',
  deleteDeviceGroup: 'Device group successfully deleted',
  updateOperationCalendarEvent: 'Operation calendar event successfully updated',
  updateOperationEvent: 'Operation calendar event successfully updated',
  invalidateOperationEvent: 'Operation calendar event successfully invalidated',
  deleteOperationCalendarEvent: 'Operation calendar event successfully deleted',
  createDeliveryContract: 'Delivery contract successfully created',
  updateDeliveryContract: 'Delivery contract successfully updated',
  assignDeliveryPoint:
    'Delivery point successfully assign to delivery contract',
  assignDeliveryPointChange: 'Delivery point assignment successfully changed',
  unassignDeliveryPoint: 'Delivery point successfully unassign'
};

export default enEaiMessages;
